import React, { useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core";
import EmploymentApplicationsList from "./companyEmployeeJoinRequest";
import Pagination from "@material-ui/lab/Pagination";

// ─── Stub Data ────────────────────────────────────────────────────────────────
const STUB_DATA = [
  {
    id: "3fa85f64-0001",
    employee_id: "EMP-10001",
    state: "SUBMITTED",
    validation_status: "PENDING",
    validation_report: "Awaiting review",
    is_editable: false,
    is_submitted: true,
    is_approved: false,
    is_rejected: false,
    is_draft: false,
    rejection_reason: null,
    submitted_at: "2026-05-10T09:00:00.000Z",
    approved_at: null,
    rejected_at: null,
    withdrawn_at: null,
    created_at: "2026-05-09T08:00:00.000Z",
    updated_at: "2026-05-10T09:00:00.000Z",
    email: "amara.okafor@company.ng",
    employment_data: {
      email: "amara.okafor@company.ng",
      employee_id: "EMP-10001",
      first_name: "Amara",
      last_name: "Okafor",
      gender: "F",
      withdrawal_percent: "15.00",
      branch: "Lagos HQ",
      profile: {
        position: "Software Engineer",
        phone: "+234 8012345678",
        salary: "450000",
        savings: "120000",
        nin: "NIN12345678901",
        bvn: "BVN22345678901",
      },
      bank: {
        name: "GTBank",
        number: "0123456789",
        account_holder: "Amara Okafor",
      },
    },
  },
  {
    id: "3fa85f64-0002",
    employee_id: "EMP-10002",
    state: "APPROVED",
    validation_status: "APPROVED",
    validation_report: "All checks passed",
    is_editable: false,
    is_submitted: true,
    is_approved: true,
    is_rejected: false,
    is_draft: false,
    rejection_reason: null,
    submitted_at: "2026-05-08T11:30:00.000Z",
    approved_at: "2026-05-12T14:00:00.000Z",
    rejected_at: null,
    withdrawn_at: null,
    created_at: "2026-05-07T10:00:00.000Z",
    updated_at: "2026-05-12T14:00:00.000Z",
    email: "tunde.adeyemi@company.ng",
    employment_data: {
      email: "tunde.adeyemi@company.ng",
      employee_id: "EMP-10002",
      first_name: "Tunde",
      last_name: "Adeyemi",
      gender: "M",
      withdrawal_percent: "20.00",
      branch: "Abuja Branch",
      profile: {
        position: "Product Manager",
        phone: "+234 8023456789",
        salary: "600000",
        savings: "200000",
        nin: "NIN23456789012",
        bvn: "BVN33456789012",
      },
      bank: {
        name: "Access Bank",
        number: "0234567890",
        account_holder: "Tunde Adeyemi",
      },
    },
  },
  {
    id: "3fa85f64-0003",
    employee_id: "EMP-10003",
    state: "REJECTED",
    validation_status: "FAILED",
    validation_report: "BVN mismatch detected",
    is_editable: false,
    is_submitted: true,
    is_approved: false,
    is_rejected: true,
    is_draft: false,
    rejection_reason: "BVN provided does not match the name on the bank account. Please resubmit with correct details.",
    submitted_at: "2026-05-06T08:45:00.000Z",
    approved_at: null,
    rejected_at: "2026-05-11T10:00:00.000Z",
    withdrawn_at: null,
    created_at: "2026-05-05T07:00:00.000Z",
    updated_at: "2026-05-11T10:00:00.000Z",
    email: "chioma.ibrahim@company.ng",
    employment_data: {
      email: "chioma.ibrahim@company.ng",
      employee_id: "EMP-10003",
      first_name: "Chioma",
      last_name: "Ibrahim",
      gender: "F",
      withdrawal_percent: "10.00",
      branch: "Port Harcourt",
      profile: {
        position: "UX Designer",
        phone: "+234 8034567890",
        salary: "380000",
        savings: "80000",
        nin: "NIN34567890123",
        bvn: "BVN44567890123",
      },
      bank: {
        name: "Zenith Bank",
        number: "0345678901",
        account_holder: "Chioma Ibrahim",
      },
    },
  },
  {
    id: "3fa85f64-0004",
    employee_id: "EMP-10004",
    state: "DRAFT",
    validation_status: "PENDING",
    validation_report: "",
    is_editable: true,
    is_submitted: false,
    is_approved: false,
    is_rejected: false,
    is_draft: true,
    rejection_reason: null,
    submitted_at: null,
    approved_at: null,
    rejected_at: null,
    withdrawn_at: null,
    created_at: "2026-05-15T13:00:00.000Z",
    updated_at: "2026-05-15T13:00:00.000Z",
    email: "emeka.nwosu@company.ng",
    employment_data: {
      email: "emeka.nwosu@company.ng",
      employee_id: "EMP-10004",
      first_name: "Emeka",
      last_name: "Nwosu",
      gender: "M",
      withdrawal_percent: "25.00",
      branch: "Kano Office",
      profile: {
        position: "Data Analyst",
        phone: "+234 8045678901",
        salary: "320000",
        savings: "60000",
        nin: "NIN45678901234",
        bvn: "BVN55678901234",
      },
      bank: {
        name: "First Bank",
        number: "0456789012",
        account_holder: "Emeka Nwosu",
      },
    },
  },
  {
    id: "3fa85f64-0005",
    employee_id: "EMP-10005",
    state: "SUBMITTED",
    validation_status: "PENDING",
    validation_report: "Under review",
    is_editable: false,
    is_submitted: true,
    is_approved: false,
    is_rejected: false,
    is_draft: false,
    rejection_reason: null,
    submitted_at: "2026-05-18T10:15:00.000Z",
    approved_at: null,
    rejected_at: null,
    withdrawn_at: null,
    created_at: "2026-05-17T09:00:00.000Z",
    updated_at: "2026-05-18T10:15:00.000Z",
    email: "fatima.adeleke@company.ng",
    employment_data: {
      email: "fatima.adeleke@company.ng",
      employee_id: "EMP-10005",
      first_name: "Fatima",
      last_name: "Adeleke",
      gender: "F",
      withdrawal_percent: "12.50",
      branch: "Ibadan Hub",
      profile: {
        position: "HR Officer",
        phone: "+234 8056789012",
        salary: "290000",
        savings: "50000",
        nin: "NIN56789012345",
        bvn: "BVN66789012345",
      },
      bank: {
        name: "UBA",
        number: "0567890123",
        account_holder: "Fatima Adeleke",
      },
    },
  },
  {
    id: "3fa85f64-0006",
    employee_id: "EMP-10006",
    state: "APPROVED",
    validation_status: "APPROVED",
    validation_report: "Verified successfully",
    is_editable: false,
    is_submitted: true,
    is_approved: true,
    is_rejected: false,
    is_draft: false,
    rejection_reason: null,
    submitted_at: "2026-05-05T14:00:00.000Z",
    approved_at: "2026-05-09T11:00:00.000Z",
    rejected_at: null,
    withdrawn_at: null,
    created_at: "2026-05-04T12:00:00.000Z",
    updated_at: "2026-05-09T11:00:00.000Z",
    email: "kola.mohammed@company.ng",
    employment_data: {
      email: "kola.mohammed@company.ng",
      employee_id: "EMP-10006",
      first_name: "Kola",
      last_name: "Mohammed",
      gender: "M",
      withdrawal_percent: "30.00",
      branch: "Lagos HQ",
      profile: {
        position: "Finance Lead",
        phone: "+234 8067890123",
        salary: "720000",
        savings: "350000",
        nin: "NIN67890123456",
        bvn: "BVN77890123456",
      },
      bank: {
        name: "GTBank",
        number: "0678901234",
        account_holder: "Kola Mohammed",
      },
    },
  },
  {
    id: "3fa85f64-0007",
    employee_id: "EMP-10007",
    state: "DRAFT",
    validation_status: "PENDING",
    validation_report: "",
    is_editable: true,
    is_submitted: false,
    is_approved: false,
    is_rejected: false,
    is_draft: true,
    rejection_reason: null,
    submitted_at: null,
    approved_at: null,
    rejected_at: null,
    withdrawn_at: null,
    created_at: "2026-05-20T08:00:00.000Z",
    updated_at: "2026-05-20T08:00:00.000Z",
    email: "ngozi.obi@company.ng",
    employment_data: {
      email: "ngozi.obi@company.ng",
      employee_id: "EMP-10007",
      first_name: "Ngozi",
      last_name: "Obi",
      gender: "F",
      withdrawal_percent: "18.00",
      branch: "Abuja Branch",
      profile: {
        position: "Operations Manager",
        phone: "+234 8078901234",
        salary: "550000",
        savings: "180000",
        nin: "NIN78901234567",
        bvn: "BVN88901234567",
      },
      bank: {
        name: "Access Bank",
        number: "0789012345",
        account_holder: "Ngozi Obi",
      },
    },
  },
  {
    id: "3fa85f64-0008",
    employee_id: "EMP-10008",
    state: "SUBMITTED",
    validation_status: "PENDING",
    validation_report: "Pending NIN verification",
    is_editable: false,
    is_submitted: true,
    is_approved: false,
    is_rejected: false,
    is_draft: false,
    rejection_reason: null,
    submitted_at: "2026-05-21T16:00:00.000Z",
    approved_at: null,
    rejected_at: null,
    withdrawn_at: null,
    created_at: "2026-05-20T15:00:00.000Z",
    updated_at: "2026-05-21T16:00:00.000Z",
    email: "bayo.bello@company.ng",
    employment_data: {
      email: "bayo.bello@company.ng",
      employee_id: "EMP-10008",
      first_name: "Bayo",
      last_name: "Bello",
      gender: "M",
      withdrawal_percent: "22.00",
      branch: "Port Harcourt",
      profile: {
        position: "Software Engineer",
        phone: "+234 8089012345",
        salary: "430000",
        savings: "95000",
        nin: "NIN89012345678",
        bvn: "BVN99012345678",
      },
      bank: {
        name: "First Bank",
        number: "0890123456",
        account_holder: "Bayo Bello",
      },
    },
  },
];

// ─── Simple pagination styles ─────────────────────────────────────────────────
const usePaginationStyles = makeStyles(() => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 16,
    justifyContent: "flex-end",
  },
  pageInfo: {
    fontSize: 13,
    color: "#8892a4",
    fontFamily: "inherit",
    minWidth: 100,
    textAlign: "center",
  },
  navBtn: {
    minWidth: 36,
    height: 36,
    borderRadius: 8,
    border: "1.5px solid #EAEAEA",
    background: "#fff",
    color: "#8892a4",
    padding: 0,
    "&:hover": {
      background: "#ECF3FF",
      borderColor: "#3E83FB",
      color: "#3E83FB",
    },
    "&:disabled": {
      opacity: 0.35,
    },
  },
  pageBtn: {
    minWidth: 36,
    height: 36,
    borderRadius: 8,
    border: "1.5px solid #EAEAEA",
    background: "#fff",
    color: "#8892a4",
    fontSize: 13,
    fontWeight: 600,
    padding: 0,
    "&:hover": {
      background: "#ECF3FF",
      borderColor: "#3E83FB",
      color: "#3E83FB",
    },
  },
  pageBtnActive: {
    background: "#3E83FB",
    borderColor: "#3E83FB",
    color: "#fff",
    "&:hover": {
      background: "#2A6FE6",
    },
  },
}));


// ─── Demo wrapper ─────────────────────────────────────────────────────────────
const ROWS_PER_PAGE = 10;

export default function EmploymentApplication({
  handleApprove: externalHandleApprove,
  handleReject: externalHandleReject,
  handleSaveEdit: externalHandleSaveEdit,
  records: externalRecords,
  totalPages: externalTotalPages,
  onPageChange: externalOnPageChange,
  page: externalPage,
  total: externalTotal,
  loading: externalLoading,
  saveLoading = false,
  closeDrawerOnSave = true,
  approveLoading = false,
  rejectLoading = false
}) {
  const [records, setRecords] = useState(STUB_DATA);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const total = records.length;
  const totalPages = Math.ceil(total / ROWS_PER_PAGE);
  const pageData = records.slice((page - 1) * ROWS_PER_PAGE, page * ROWS_PER_PAGE);

  // Simulate an API fetch
  const simulateRefetch = () => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1800);
  };

  const handleApprove = (id) => {
    setRecords((prev) =>
      prev.map((r) =>
        r.id === id
          ? { ...r, state: "APPROVED", is_approved: true, is_rejected: false, is_draft: false, is_editable: false }
          : r
      )
    );
  };

  const handleReject = (id, reason) => {
    setRecords((prev) =>
      prev.map((r) =>
        r.id === id
          ? { ...r, state: "REJECTED", is_rejected: true, is_approved: false, is_draft: false, is_editable: false, rejection_reason: reason }
          : r
      )
    );
  };

  const handleSaveEdit = (id, updatedEmploymentData) => {
    setRecords((prev) =>
      prev.map((r) =>
        r.id === id ? { ...r, employment_data: updatedEmploymentData } : r
      )
    );
  };

  return (
    <EmploymentApplicationsList
      data={externalRecords || pageData}
      loading={externalLoading || loading}
      total={externalTotal || total}
      onApprove={externalHandleApprove || handleApprove}
      onReject={externalHandleReject || handleReject}
      onSaveEdit={externalHandleSaveEdit || handleSaveEdit}
      saveLoading={saveLoading}
      closeDrawerOnSave={closeDrawerOnSave}
      approveLoading={approveLoading}
      rejectLoading={rejectLoading}
      paginationComponent={
        <Pagination
          page={externalPage || page}
          count={externalTotalPages || totalPages}
          showFirstButton
          showLastButton
          onChange={(event, value) => {
            externalOnPageChange?.(value)
          }}
        />
      }
    />
  );
}